import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  HostBinding,
  Inject,
  Input
} from '@angular/core';
import { PipesModule } from '../../../pipes/pipes.module';
import { FormAccessibilityService } from './form-accessibility.service';
import type {
  OnChanges,
  OnDestroy,
  OnInit,
  SimpleChanges
} from '@angular/core';
import type { Observable, Subscription } from 'rxjs';

import type { AccessibleErrors } from '../domain/form.domain';

@Component({
  selector: 'td-wb-form-accessibility-alert',
  templateUrl: 'form-accessibility-alert.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [PipesModule]
})
export class FormAccessibilityAlertComponent implements OnInit, OnChanges, OnDestroy {
  @Input() alertOnLoad: boolean;
  @HostBinding('attr.role') role: string = null;

  accessibleErrors: AccessibleErrors;
  displayedAccessibleErrors: Array<string>;
  private errorsObservable: Observable<AccessibleErrors>;
  private subscription: Subscription;
  private readonly isModalAlert: boolean = false;

  constructor(@Inject(FormAccessibilityService) private formAccessibilityService: FormAccessibilityService,
              @Inject(ChangeDetectorRef) private changeDetectorRef: ChangeDetectorRef) {
    this.isModalAlert = this.formAccessibilityService.isModal();
  }

  ngOnInit(): void {
    this.errorsObservable = this.formAccessibilityService.register(this.isModalAlert);
    if (this.errorsObservable !== undefined) {
      this.subscription = this.errorsObservable.subscribe((value: AccessibleErrors) => {
        this.updateErrors(value);
      });
    }
    if (this.alertOnLoad) {
      this.role = 'alert';
      this.toggleAlert();
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes !== undefined && changes.showAccessibleErrors.currentValue) {
      this.changeDetectorRef.markForCheck();
    }
  }

  ngOnDestroy(): void {
    if (this.subscription !== undefined) {
      this.subscription.unsubscribe();
      if (this.isModalAlert) {
        this.formAccessibilityService.shouldSubscribeToModalAlerts = true;
      } else {
        this.formAccessibilityService.shouldSubscribeToPageAlerts = true;
      }
    }
  }

  updateErrors(value: AccessibleErrors): void {
    this.accessibleErrors = value;

    this.displayedAccessibleErrors = Object.keys(value)
      .filter((error: string): boolean => value[error].isDisplayed);
    if (Object.keys(this.displayedAccessibleErrors).length > 0) {
      this.role = 'alert';
    } else {
      this.role = null;
    }
    this.changeDetectorRef.markForCheck();
  }

  getAccessibleError(key: string): string {
    return key.replace(FormAccessibilityService.ERROR_KEY_SUFFIX, '') + ' ';
  }

  showErrors(): boolean {
    return this.role !== null && this.errorsObservable !== undefined;
  }

  private toggleAlert(): void {
    setTimeout((): void => {
      this.role = 'alert';
    });
  }
}
